module.exports = __webpack_public_path__ + "slipper.jpg?d2810e03c7fcfe2f7000be6f5b32a255";